import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { TrendingUp, Shield } from 'lucide-react';

const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://www.echt.gold';

const Silberankauf = () => {
  return (
    <>
      <Helmet>
        <title>Silberankauf - Echt Gold | Faire Preise für Silber</title>
        <meta name="description" content="Professioneller Silberankauf - Barren, Münzen, Schmuck. Faire Bewertung nach Tageskurs. Sofortige Auszahlung in NRW." />
        <link rel="canonical" href={`${BASE_URL}/silberankauf`} />
      </Helmet>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {"@type": "ListItem", "position": 1, "name": "Home", "item": `${BASE_URL}/`},
            {"@type": "ListItem", "position": 2, "name": "Silberankauf", "item": `${BASE_URL}/silberankauf`}
          ]
        })}
      </script>

      <div className="bg-black/90 py-8 border-b border-gold/20">
        <div className="container mx-auto px-4">
          <div className="text-sm text-gray-400 mb-2">
            <Link to="/" className="hover:text-gold">Home</Link> / <span className="text-gold">Silberankauf</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold gold-text">Silberankauf</h1>
        </div>
      </div>

      <section className="section section-dark">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold mb-6 gold-text text-center">Silber zu fairen Preisen verkaufen</h2>
            <p className="text-gray-300 mb-8 text-lg text-center">
              Wir kaufen Silber in allen Formen - Barren, Münzen, Schmuck und Tafelsilber. Professionelle Bewertung und transparente Preise nach aktuellem Tageskurs.
            </p>
            
            <div className="grid md:grid-cols-3 gap-6 mb-12">
              <div className="card text-center">
                <h3 className="text-xl font-bold mb-3 gold-text">Silbermünzen</h3>
                <ul className="text-gray-300 space-y-2 text-left">
                  <li>• Maple Leaf</li>
                  <li>• Wiener Philharmoniker</li>
                  <li>• American Eagle</li>
                  <li>• Britannia</li>
                  <li>• Historische Münzen</li>
                </ul>
              </div>
              <div className="card text-center">
                <h3 className="text-xl font-bold mb-3 gold-text">Silberbarren</h3>
                <ul className="text-gray-300 space-y-2 text-left">
                  <li>• 1 oz - 1 kg Barren</li>
                  <li>• Heraeus</li>
                  <li>• Umicore</li>
                  <li>• Degussa</li>
                  <li>• Alle Hersteller</li>
                </ul>
              </div>
              <div className="card text-center">
                <h3 className="text-xl font-bold mb-3 gold-text">Silberschmuck</h3>
                <ul className="text-gray-300 space-y-2 text-left">
                  <li>• Sterling Silber (925)</li>
                  <li>• Ketten & Armbänder</li>
                  <li>• Ringe & Anhänger</li>
                  <li>• Tafelsilber</li>
                  <li>• Silberbesteck</li>
                </ul>
              </div>
            </div>

            <div className="card">
              <h3 className="text-2xl font-bold mb-4 gold-text">Warum Silber bei Echt Gold verkaufen?</h3>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="flex gap-3">
                  <TrendingUp className="text-gold flex-shrink-0" size={24} />
                  <div>
                    <h4 className="font-bold mb-1">Tagesaktuelle Preise</h4>
                    <p className="text-gray-300 text-sm">Faire Bewertung basierend auf aktuellem Silberpreis</p>
                  </div>
                </div>
                <div className="flex gap-3">
                  <Shield className="text-gold flex-shrink-0" size={24} />
                  <div>
                    <h4 className="font-bold mb-1">Seriöse Abwicklung</h4>
                    <p className="text-gray-300 text-sm">Transparenz und Vertrauen seit über 15 Jahren</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-darker">
        <div className="container">
          <div className="card text-center max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold mb-4 gold-text">Silber jetzt verkaufen</h2>
            <p className="text-gray-300 mb-8">
              Vereinbaren Sie einen Termin oder fordern Sie ein kostenloses Versandlabel an
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Link to="/kontakt" className="btn-primary">Jetzt Kontakt aufnehmen</Link>
              <Link to="/versandankauf" className="btn-secondary">Versandankauf nutzen</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Silberankauf;